const listen = () => {
  accountMenu();
  loginOverlay();
  initAccountMenuObserver();
};

const accountMenu = () => {
  // Get the user menu element
  const userMenuElement = document.getElementById('community-user-menu');

  if (!userMenuElement) {
    return;
  }

  // Create and send XHR request to get user menu content
  const xhr = new XMLHttpRequest();
  xhr.open('GET', '/?type=1746603090', true);

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      // Update the menu content on success
      userMenuElement.innerHTML = xhr.responseText;
      // Trigger bind-components event after content is loaded
      document.dispatchEvent(new CustomEvent('bind-components'));
    } else {
      console.error('Request failed with status:', xhr.status);
    }
  };

  xhr.onerror = function () {
    console.error('Request failed');
  };

  xhr.send();
};

const BindLoginOverlay = () => {
  const overlayTemplate = document.getElementById('login-overlay');
  if (overlayTemplate) {
    new window.Overlay(overlayTemplate);
  }
};

const loginOverlay = () => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', '/?type=1746603091', true);

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      // Try to parse as JSON first
      try {
        const response = JSON.parse(xhr.responseText);
        if (response.success) {
          return; // User is logged in, no need to show overlay
        }
      } catch (e) {
        // Not JSON, treat as HTML
        // Append the login overlay to the body
        const mainElement = document.getElementById('site');
        if (mainElement) {
          mainElement.insertAdjacentHTML('beforeend', xhr.responseText);
        } else {
          // Fallback to body if main element doesn't exist
          document.body.insertAdjacentHTML('beforeend', xhr.responseText);
        }

        // Wait for the DOM to be updated
        setTimeout(() => {
          BindLoginOverlay();
          // Show the overlay
          const overlayTemplate = document.querySelector(
            '.overlay__template:not(.overlay__template--bound)'
          );
          if (overlayTemplate) {
            overlayTemplate.dispatchEvent(new CustomEvent('overlay-show', { bubbles: false }));
          }
        }, 0);
      }
    } else {
      console.error('Request failed with status:', xhr.status);
    }
  };

  xhr.onerror = function () {
    console.error('Request failed');
  };

  xhr.send();
};

// Initialize MutationObserver to watch for dynamically added elements
const initAccountMenuObserver = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        // Check if any of the added nodes are account menus
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Element node
            if (node.classList && node.classList.contains('account-menu')) {
              new AccountMenu(node);
            }
            // Also check for account menus within the added node
            const accountMenus = node.querySelectorAll('.account-menu:not(.account-menu--bound)');
            accountMenus.forEach((menu) => {
              new AccountMenu(menu);
            });
          }
        });
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

document.addEventListener('DOMContentLoaded', function () {
  listen();
});

class AccountMenu {
  constructor(el) {
    console.log('AccountMenu constructor', el);
    this.$el = el;
    this.$button = this.$el.querySelector('.account-menu__button');
    this.$logOutButton = this.$el.querySelector('.account-menu__log-out');
    console.log('this.$button', this.$button);
    this.loggedIn = this.$el.classList.contains('account-menu--logged-in');
    this.loginOverlayId = this.$el.dataset?.loginOverlayId || false;
    this.logOutViaApi = this.$el.classList.contains('account-menu--logout-via-api');
    this.logOutLink = this.$logOutButton && this.logOutViaApi ? this.$logOutButton.href : false;
    this.open = this.$el.classList.contains('account-menu--open');

    this.InitEvents();
    this.$el.classList.add('account-menu--bound');
  }

  InitEvents() {
    const self = this;
    this.$button.addEventListener('click', (e) => {
      if (self.loggedIn) {
        self.SetMenuState(!self.open);
      } else {
        if (self.loginOverlayId) {
          const overlayElement = document.getElementById(self.loginOverlayId);
          console.log('overlayElement', overlayElement);
          if (overlayElement) {
            // Show the login overlay
            overlayElement.dispatchEvent(new CustomEvent('overlay-show', { bubbles: false }));
          } else {
            console.error('Login overlay element not found:', self.loginOverlayId);
          }
        }
      }
    });

    if (this.logOutViaApi && this.$logOutButton) {
      this.$logOutButton.addEventListener('click', (e) => {
        e.preventDefault();
        self.LogOutViaApi();
      });
    }
  }

  LogOutViaApi() {
    if (this.logOutLink) {
      window.appUtils.XMLHttpRequest('GET', this.logOutLink, () => {
        window.location.reload();
      });
    }
  }

  SetMenuState(open) {
    this.open = open;
    if (this.open) {
      this.$el.classList.add('account-menu--open');
    } else {
      this.$el.classList.remove('account-menu--open');
    }
  }
}

const BindAccountMenus = () => {
  document.querySelectorAll('.account-menu:not(.account-menu--bound)').forEach((el) => {
    new AccountMenu(el);
  });
};

window.addEventListener('bind-components', BindAccountMenus);
